import { useCallback, useState } from 'react'
import { startRegistration } from '@simplewebauthn/browser'
import { authService } from '@/services/auth'

interface RegisterResult {
    success: boolean
    error?: string
}

export function useWebAuthnRegister() {
    const [loading, setLoading] = useState(false)

    const register = useCallback(async (username: string): Promise<RegisterResult> => {
        setLoading(true)
        try {
            // Step 1: Get registration options from server
            const options = await authService.beginRegistration(username)

            // Step 2: Start the WebAuthn registration ceremony
            const attestation = await startRegistration(options)

            // Step 3: Send the attestation to the server for verification
            const verification = await authService.completeRegistration(attestation, username)

            if (verification.verified) {
                return { success: true }
            } else {
                return { success: false, error: 'Registration verification failed' }
            }
        } catch (err: any) {
            console.error('Registration failed:', err)
            return {
                success: false,
                error: err.message || 'Registration failed'
            }
        } finally {
            setLoading(false)
        }
    }, [])

    return { register, loading }
}
